var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFOdvbcNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 40,
    viewBox: "0 0 24 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.30825 15.2502C6.68882 15.2502 4.55817 13.1195 4.55817 10.5001C4.55817 7.88065 6.68882 5.75 9.30825 5.75C11.9277 5.75 14.0583 7.88065 14.0583 10.5001C14.058 13.1195 11.9274 15.2502 9.30825 15.2502ZM9.30825 7.33373C7.56206 7.33373 6.14153 8.75426 6.14153 10.5005C6.14153 12.2466 7.56206 13.6672 9.30825 13.6672C11.0544 13.6672 12.475 12.2466 12.475 10.5005C12.475 8.75426 11.0541 7.33373 9.30825 7.33373Z",
    fill: "#644EB2",
    stroke: "#644EB2",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.39258 38.9998C1.33458 38.9998 1.27572 38.9935 1.21714 38.9805C0.790711 38.8838 0.523372 38.4602 0.619569 38.0335L6.1685 13.4917C6.26556 13.0653 6.69084 12.7994 7.11555 12.8942C7.54197 12.9909 7.80931 13.4145 7.71312 13.8412L2.16418 38.383C2.0812 38.7505 1.75442 38.9998 1.39261 38.9998L1.39258 38.9998Z",
    fill: "#644EB2",
    stroke: "#644EB2",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2239 38.9998C16.8621 38.9998 16.5356 38.7505 16.4524 38.3824L10.9109 13.8406C10.8147 13.4142 11.0826 12.9901 11.509 12.8939C11.9334 12.8 12.3589 13.065 12.4558 13.492L17.9973 38.0338C18.0935 38.4602 17.8255 38.8843 17.3991 38.9805C17.3405 38.9938 17.282 38.9998 17.224 38.9998H17.2239Z",
    fill: "#644EB2",
    stroke: "#644EB2",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30824 7.33352C8.87091 7.33352 8.51652 6.97917 8.51652 6.5418L8.51624 1.79172C8.51624 1.35438 8.87058 1 9.30795 1C9.74532 1 10.0997 1.35435 10.0997 1.79172L10.1 6.5418C10.1 6.97914 9.74532 7.33352 9.30824 7.33352Z",
    fill: "#644EB2",
    stroke: "#644EB2",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31634 24.7502C7.71916 24.7502 6.13727 24.478 4.59809 23.9372C4.18573 23.7922 3.96865 23.3405 4.11366 22.9279C4.25868 22.5158 4.70922 22.299 5.12297 22.4435C6.87865 23.06 8.6943 23.2843 10.52 23.1088C13.8877 22.7852 16.9279 21.1694 19.0804 18.5594C21.2332 15.9489 22.24 12.6567 21.9166 9.28891C21.8963 9.07096 21.8601 8.85875 21.8248 8.64654L21.7955 8.46822C21.726 8.03634 22.0189 7.63034 22.4508 7.56021C22.8867 7.48985 23.2886 7.7839 23.3588 8.21549L23.3869 8.38664C23.4283 8.63474 23.4688 8.88341 23.4932 9.13785C23.857 12.9266 22.7239 16.6301 20.3023 19.5669C17.8805 22.5036 14.4599 24.321 10.6716 24.6851C10.2185 24.7282 9.76652 24.75 9.31619 24.75L9.31634 24.7502Z",
    fill: "#644EB2",
    stroke: "#644EB2",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFOdvbcNo);
export default __webpack_public_path__ + "static/media/FOdvbcNO.ba0603349a7c96b0f7ce8cd5ff7c578b.svg";
export { ForwardRef as ReactComponent };